module.exports = __webpack_public_path__ + "static/media/34DSS7.67b86840.jpg";